<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Transações Suspeitas</h3>
        </div>

        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
              v-b-tooltip.hover.bottom
              title="Filtros"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Transações</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Empresa</th>
                    <th scope="col" class="border-0 text-left">Confiável</th>
                    <!-- <th scope="col" class="border-0">Transação</th> -->
                    <!-- <th scope="col" class="border-0">Forma de Pagamento</th> -->
                    <th scope="col" class="border-0">Data de Pagamento</th>
                    <th scope="col" class="border-0">Status</th>
                    <th scope="col" class="border-0" style="width: 15%" v-if="showStatus">
                      Análise
                    </th>
                    <th scope="col" class="border-0">Data de Criação</th>
                    <th
                      scope="col"
                      class="border-0"
                      v-if="$isAuthorize('SuspectTransaction', 'Get') || $isAuthorize('SuspectTransaction', 'Check')"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(suspectTransaction, index) in listSuspectTransaction" :key="index">
                    <td></td>
                    <td class="text-left td-with-subs">
                      <div>
                        {{ suspectTransaction.NameMerchant | substring(50) }}
                      </div>
                      <span>{{ suspectTransaction.IdentityMerchant | identity }}</span>
                    </td>
                    <td>
                      <i :class="[GetTrustClass(suspectTransaction.IsTrustable)]"></i>
                    </td>
                    <!-- <td>{{ suspectTransaction.PaymentMethod.Name }}</td> -->
                    <td>
                      <div v-if="suspectTransaction.PaymentDate != '0001-01-01T00:00:00'">
                        {{ suspectTransaction.PaymentDate | date }}
                      </div>
                      <span v-if="suspectTransaction.PaymentDate != '0001-01-01T00:00:00'">{{
                        suspectTransaction.PaymentDate | date("HH:mm:ss")
                      }}</span>

                      <div class="td-span-style" v-if="suspectTransaction.PaymentDate == '0001-01-01T00:00:00'">
                        Não houve
                      </div>
                      <span class="td-span-style" v-if="suspectTransaction.PaymentDate == '0001-01-01T00:00:00'"
                        >pagamento</span
                      >
                    </td>
                    <td>
                      <span class="label rounded" :class="suspectTransaction | StatusColor">{{
                        suspectTransaction | StatusText
                      }}</span>
                    </td>
                    <td v-if="showStatus">
                      <span class="label rounded" :class="suspectTransaction | StatusColorFraud">{{
                        suspectTransaction | StatusTextFraud
                      }}</span>
                    </td>
                    <td class="td-with-subs">
                      <div>{{ suspectTransaction.CreatedDate | date }}</div>
                      <span>{{ suspectTransaction.CreatedDate | date("HH:mm:ss") }}</span>
                    </td>
                    <td v-if="$isAuthorize('SuspectTransaction', 'Get') || $isAuthorize('SuspectTransaction', 'Check')">
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            v-if="$isAuthorize('SuspectTransaction', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenModal(index)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="!suspectTransaction.IsValid && $isAuthorize('SuspectTransaction', 'Check')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenModalUpdate(index)"
                          >
                            <i class="fas fa-user-edit"></i> Atualizar
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      listSuspectTransaction == undefined ||
                        listSuspectTransaction == null ||
                        listSuspectTransaction.length == 0
                    "
                  >
                    <td colspan="12">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="mFormUpdate" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <template v-slot:modal-header>
        <h5 class="col-10 no-gutters mb-0">
          <template>{{ nameMerchant }}</template>
        </h5>
        <button class="close" @click="HideModalUpdate()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <loader :is-loading="loadingMerchant"></loader>
      <div v-if="!loadingMerchant">
        <d-form-row v-if="!loadingMerchant">
          <d-col md="12" class="form-group">
            <label>Escolha o Status</label>
            <d-select v-model="suspectTransactionUpdate.CodeSuspectTransactionStatus" :value="null">
              <option :value="null" selected>Status</option>
              <option v-for="type in suspectTransactionStatus" v-bind:key="type.Code" v-bind:value="type.Code">
                {{ type.Name }}
              </option>
            </d-select>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col md="12" class="form-group">
            <label v-b-tooltip.hover title="JSON">Descrição</label>
            <b-form-textarea type="text" :rows="5" v-model="suspectTransactionUpdate.Description" />
          </d-col>
        </d-form-row>
      </div>
      <template slot="modal-footer">
        <b-button-group>
          <b-button type="button" class="btn btn-success" :disabled="loadingUpdate" v-on:click="OpenCheckTrustable()">
            <template v-if="!loadingUpdate"
              >Salvar</template
            >
            <template v-else>
              <loader :small="true" :isLoading="loadingUpdate"></loader>
            </template>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>

    <b-modal size="lg" id="mFormTransaction" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <template v-slot:modal-header>
        <h5 class="col-10 no-gutters mb-0">
          <template>{{ infoTransaction.NameMerchant }}</template>
          <template>
            - [{{ infoTransaction.SuspectTransactionStatus.Name }}]</template
          >
        </h5>
        <button class="close" @click="HideModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <loader :is-loading="loadingMerchant"></loader>
      <div v-if="!loadingMerchant">
        <d-form-row v-if="!loadingMerchant">
          <d-col md="3"></d-col>
          <d-col md="8">
            <div class="form-group">
              <div :class="GetClass()">
                <p class="labelModalText">{{ infoTransaction | StatusText }}</p>
              </div>
            </div>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col md="2" class="form-group">
            <label>Id</label>
            <d-form-input type="text" v-model="infoTransaction.IdMerchant" :disabled="isSeeing" />
          </d-col>
          <d-col md="7" class="form-group">
            <label>Nome</label>
            <d-form-input type="text" v-model="infoTransaction.NameMerchant" :disabled="isSeeing" />
          </d-col>
          <d-col md="3" class="form-group">
            <label>CPF/CNPJ</label>
            <the-mask
              class="form-control"
              type="tel"
              :disabled="isSeeing"
              :mask="['###.###.###-##', '##.###.###/####-##']"
              v-model="infoTransaction.IdentityMerchant"
            />
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col md="4" class="form-group">
            <label>Valor</label>
            <d-form-input type="text" v-bind:value="infoTransaction.Amount | currency" :disabled="isSeeing" />
          </d-col>
          <d-col md="4" class="form-group" v-if="infoTransaction.PaymentDate != '0001-01-01T00:00:00'">
            <label>Data de pagamento</label>
            <d-form-input type="text" v-bind:value="infoTransaction.PaymentDate | date('DD/MM/YYYY - HH:mm')" readonly />
          </d-col>
          <d-col md="4" class="form-group">
            <label>Forma de pagamento</label>
            <d-form-input type="text" v-model="infoTransaction.PaymentMethod.Name" :disabled="isSeeing" />
          </d-col>
          <d-col md="4" class="form-group">
            <label>Data de criação</label>
            <d-form-input type="text" v-bind:value="infoTransaction.CreatedDate | date('DD/MM/YYYY - HH:mm')" readonly />
          </d-col>
        </d-form-row>
        <d-form-row>
          
          <d-col md="4" class="form-group">
            <label>IP</label>
            <d-form-input type="text" v-model="infoTransaction.IpAddress" :disabled="isSeeing" />
          </d-col>
          <d-col md="4" class="form-group">
            <label>IP de conexão</label>
            <d-form-input type="text" v-model="infoTransaction.RemoteIpAddress" :disabled="isSeeing" />
          </d-col>
          <d-col md="4" class="form-group">
            <label>Fingerprint</label>
            <d-form-input type="text" v-model="infoTransaction.Fingerprint" :disabled="isSeeing" />
          </d-col>
        </d-form-row>
        <div v-if="infoTransaction.IdMerchantRoot > 0">
          <h4>Marketplace</h4>
          <hr />
          <d-form-row>
            <d-col md="2" class="form-group">
              <label>Id</label>
              <d-form-input type="text" v-model="infoTransaction.IdMerchantRoot" :disabled="isSeeing" />
            </d-col>
            <d-col md="7" class="form-group">
              <label>Nome</label>
              <d-form-input type="text" v-model="infoTransaction.NameMerchantRoot" :disabled="isSeeing" />
            </d-col>
            <d-col md="3" class="form-group">
              <label>CPF/CNPJ</label>
              <the-mask
                class="form-control"
                type="tel"
                :disabled="isSeeing"
                :mask="['###.###.###-##', '##.###.###/####-##']"
                v-model="infoTransaction.IdentityMerchantRoot"
              />
            </d-col>
          </d-form-row>
        </div>
        <div>
          <h4>Cliente</h4>
          <hr />
          <d-form-row>
            <d-col md="7" class="form-group">
              <label>Nome</label>
              <d-form-input type="text" v-model="infoTransaction.NameCustomer" :disabled="isSeeing" />
            </d-col>
            <d-col md="5" class="form-group">
              <label>CPF/CNPJ</label>
              <the-mask
                class="form-control"
                type="tel"
                :disabled="isSeeing"
                :mask="['###.###.###-##', '##.###.###/####-##']"
                v-model="infoTransaction.IdentityCustomer"
              />
            </d-col>
          </d-form-row>
        </div>
        <div v-if="infoTransaction.UserInternal.Id > 0">
          <h4>Usuário</h4>
          <hr />
          <d-form-row>
            <d-col md="5" class="form-group">
              <label>Nome</label>
              <d-form-input type="text" v-model="infoTransaction.UserInternal.Name" :disabled="isSeeing" />
            </d-col>
            <d-col md="4" class="form-group">
              <label>Data de Alteração</label>
              <d-form-input type="text" v-bind:value="infoTransaction.ChangeDate | date('DD/MM/YYYY - HH:mm')" readonly />
            </d-col>
            <d-col md="3" class="form-group">
              <label>Status</label>
              <d-form-input type="text" v-bind:value="infoTransaction.SuspectTransactionStatus.Name" readonly />
            </d-col>
          </d-form-row>
        </div>
      </div>
      <template slot="modal-footer">
        <b-button-group>
          <b-button size="sm" class="btn btn-secondary" hidden>
            <i class="fas fa-arrow-left"></i>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>

    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="4" class="form-group">
          <input
            placeholder="Id da Empresa"
            type="text"
            class="form-control"
            v-model="filter.IdMerchant"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="4" class="form-group">
          <input
            placeholder="Nome/Razão Social"
            type="text"
            class="form-control"
            v-model="filter.NameMerchant"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="4" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.IdentityMerchant"
            placeholder="CPF/CNPJ"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="4" class="form-group">
          <input
            placeholder="Id do Marketplace"
            type="text"
            class="form-control"
            v-model="filter.IdMerchantRoot"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="4" class="form-group">
          <input
            placeholder="Nome/Razão Social"
            type="text"
            class="form-control"
            v-model="filter.NameMerchantRoot"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="4" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.IdentityMerchantRoo"
            placeholder="CPF/CNPJ"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="4" class="form-group">
          <input
            placeholder="Id da Transação"
            type="text"
            class="form-control"
            v-model="filter.IdTransaction"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="4" class="form-group">
          <input
            placeholder="Fingerprint"
            type="text"
            class="form-control"
            v-model="filter.Fingerprint"
            v-on:keyup.enter="Filter()"
          />
        </d-col>

        <d-col md="4" class="form-group">
          <date-field v-model="filter.CreatedDate" placeholder="Data de Criação"></date-field>
        </d-col>
      </d-form-row>

      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeSuspectTransactionStatus" :value="null">
            <option :value="null" selected>Status</option>
            <option v-for="type in suspectTransactionStatus" v-bind:key="type.Code" v-bind:value="type.Code">
              {{ type.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar" @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "suspectTransaction",
  components: {
    dateField
  },
  data: function() {
    return {
      countFilter: 0,
      suspectTransactionUpdate: {
        CodeSuspectTransactionStatus: null,
        Description: null
      },
      loadingUpdate: false,
      suspectTransactionStatus: [],
      nameMerchant: null,
      showStatus: false,
      filter: {
        IsTrustable: true,
        IdMerchant: null,
        IdMerchantRoot: null,
        IdTransaction: null,
        Fingerprint: null,
        NameMerchant: null,
        IdentityMerchant: null,
        NameMerchantRoot: null,
        IdentityMerchantRoot: null,
        CreatedDate: null,
        CodeSuspectTransactionStatus: "1"
      },
      infoTransaction: {
        IpAddress:null,
        RemoteIpAddress:null,
        IdMerchant: null,
        IsTrustable: false,
        IdTransaction: null,
        Fingerprint: null, 
        NameMerchant: null,
        IdentityMerchant: null,
        IdMerchantRoot: null,
        NameMerchantRoot: null,
        IdentityMerchantRoot: null,
        Amount: null,
        PaymentDate: null,
        CreatedDate: null,
        NameCustomer: null,
        IdentityCustomer: null,
        TransactionStatus: { Name: null, Code: null },
        PaymentMethod: { Name: null },
        UserInternal: { Id: null, Name: null },
        SuspectTransactionStatus: {
          Name: null
        }
      },
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      listSuspectTransaction: [],
      idSuspectTransaction: null,
      isSeeing: true,
      loadingMerchant: false
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListSuspect();
    },
    "pagination.RowsPerPage": function() {
      this.ListSuspect();
    }
  },
  mounted() {
    this.ListSuspect();
    this.ListSuspectTransactionStatus();
  },
  methods: {
    OpenCheckTrustable: function() {
      if (!hasValue(this.suspectTransactionUpdate.CodeSuspectTransactionStatus)) {
        this.$makeToast(`O status não foi informado.`, "warning", `Transação suspeita`);
      } else {
        this.$makeMsgBox(`Deseja atualizar o status dessa transação?`, "Confirmar ação", this.CheckTrustable);
      }
    },
    ListSuspectTransactionStatus: function() {
      this.$store.dispatch("ListSuspectTransactionStatus").then(response => {
        this.suspectTransactionStatus = response;
      });
    },
    CheckTrustable: function() {
      let suspect = {
        Id: this.idSuspectTransaction,
        SuspectTransactionStatus: {
          Code: this.suspectTransactionUpdate.CodeSuspectTransactionStatus
        },
        Description: this.suspectTransactionUpdate.Description
      };
      this.loadingUpdate = true;
      this.$store
        .dispatch("CheckTrustable", suspect)
        .then(response => {
          if (response) {
            this.ListSuspect();
            this.$bvModal.hide("mFormUpdate");
            this.$makeToast(`Validação efetuada com sucesso.`, "success", `Transação suspeita`);
          } else {
            this.$makeToast(undefined, "danger", "Erro ao validar");
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao validar", error);
        })
        .finally(() => (this.loadingUpdate = false));
    },
    GetSuspectTransaction: function(id) {
      this.loadingMerchant = true;
      this.$store
        .dispatch("GetSuspectTransaction", { id: id })
        .then(response => {
          this.infoTransaction = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações da transação", error);
        })
        .finally(() => {
          this.loadingMerchant = false;
        });
    },
    HideModal: function() {
      this.$bvModal.hide("mFormTransaction");
    },
    HideModalUpdate: function() {
      this.$bvModal.hide("mFormUpdate");
    },
    GetClass: function() {
      if (this.infoTransaction != null && this.infoTransaction.Id > 0) {
        switch (this.infoTransaction.TransactionStatus.Code) {
          case "1":
            return "labelModal labelsecondary";
          case "2":
          case "5":
          case "6":
          case "12":
            return "labelModal labelwarning";
          case "11":
          case "14":
            return "labelModal labelinfo";
          case "3":
            return "labelModal labelsuccess";
          case "4":
            break;
          case "7":
          case "8":
          case "13":
            return " labelModal labeldanger";
        }
      }
    },
    OpenModalUpdate: function(i) {
      this.ResetInfoUpdate();

      // View
      this.pOpened = i;
      this.idSuspectTransaction = this.listSuspectTransaction[i].Id;
      this.nameMerchant = this.listSuspectTransaction[i].NameMerchant;
      this.isSeeing = false;
      this.modalTitle = "Atualização da transação";
      this.$bvModal.show("mFormUpdate");
    },
    OpenModal: function(i) {
      this.ResetInfo();

      // View
      this.pOpened = i;
      this.idSuspectTransaction = this.listSuspectTransaction[i].Id;
      this.isSeeing = true;
      this.modalTitle = "Detalhes da transação";
      this.GetSuspectTransaction(this.idSuspectTransaction);
      this.$bvModal.show("mFormTransaction");
    },
    GetTrustClass: function(IsTrustable) {
      return IsTrustable ? "far fa-check-circle fa-success" : "far fa-times-circle fa-danger";
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListSuspect();
    },
    ListSuspect: function() {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.IdMerchant)) this.countFilter++;
      if (hasValue(this.filter.IdMerchantRoot)) this.countFilter++;
      if (hasValue(this.filter.IdTransaction)) this.countFilter++;
      if (hasValue(this.filter.Fingerprint)) this.countFilter++;
      if (hasValue(this.filter.NameMerchant)) this.countFilter++;
      if (hasValue(this.filter.IdentityMerchant)) this.countFilter++;
      if (hasValue(this.filter.NameMerchantRoot)) this.countFilter++;
      if (hasValue(this.filter.IdentityMerchantRoot)) this.countFilter++;
      if (hasValue(this.filter.CreatedDate)) this.countFilter++;
      if (hasValue(this.filter.CodeSuspectTransactionStatus)) this.countFilter++;
      else {
        this.showStatus = true;
      }
      let data = {
        ...this.pagination,
        ...{
          "Object.IdMerchant": this.filter.IdMerchant,
          "Object.IdMerchantRoot": this.filter.IdMerchantRoot,
          "Object.IdTransaction": this.filter.IdTransaction,
          "Object.IpAddress": this.filter.IpAddress,
          "Object.RemoteIpAddress": this.filter.RemoteIpAddress,
          "Object.Fingerprint": this.filter.Fingerprint,
          "Object.NameMerchant": this.filter.NameMerchant,
          "Object.IdentityMerchant": this.filter.IdentityMerchant,
          "Object.NameMerchantRoot": this.filter.NameMerchantRoot,
          "Object.IdentityMerchantRoot": this.filter.IdentityMerchantRoot,
          "Object.CreatedDate": this.filter.CreatedDate,
          "Object.SuspectTransactionStatus.Code": this.filter.CodeSuspectTransactionStatus
        }
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListSuspectTransaction", { params: data })
        .then(response => {
          this.listSuspectTransaction = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar as transações suspeitas", error);
        })
        .finally(() => (this.loadingList = false));
    },
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    ResetFilter: function() {
      this.filter = {
        IsTrustable: true,
        IdMerchant: null,
        IdMerchantRoot: null,
        IdTransaction: null,
        Fingerprint: null,
        NameMerchant: null,
        IdentityMerchant: null,
        NameMerchantRoot: null,
        IdentityMerchantRoot: null,
        CreatedDate: null,
        CodeSuspectTransactionStatus: "1"
      };
      this.ListSuspect();
    },
    ResetInfo: function() {
      this.infoTransaction = {
        IpAddress:null,
        RemoteIpAddress:null,
        IdMerchant: null,
        IsTrustable: false,
        IdTransaction: null,
        Fingerprint: null,
        NameMerchant: null,
        IdentityMerchant: null,
        IdMerchantRoot: null,
        NameMerchantRoot: null,
        IdentityMerchantRoot: null,
        Amount: null,
        PaymentDate: null,
        CreatedDate: null,
        NameCustomer: null,
        IdentityCustomer: null,
        TransactionStatus: { Name: null, Code: null },
        PaymentMethod: { Name: null },
        UserInternal: { Id: null, Name: null },
        SuspectTransactionStatus: {
          Name: null
        }
      };
    },
    ResetInfoUpdate: function() {
      this.suspectTransactionUpdate = {
        CodeSuspectTransactionStatus: null,
        Description: null
      };
    }
  }
};
</script>
<style scoped>
.fa-danger {
  color: #ff0000;
}

.fa-warning {
  color: #e6a200;
}

.fa-secondary {
  color: #00a2bf;
}

.fa-success {
  color: #09ab6f;
}
</style>
<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.td-span-style {
  font-size: 9pt;
  opacity: 0.75;
}

.ckb {
  margin-top: 35px;
}
.fa-danger {
  color: #ff0000;
}

.labelModal {
  height: auto;
  text-overflow: ellipsis;
  width: 305px;
  border-radius: 27px;
}
.labelModalText {
  height: auto;
  word-break: break-all;
  margin-bottom: 1rem;
  text-align: center;
  font-size: 28px;
  padding: 2px;
  font-family: "Cairo", sans-serif;
}
.labelsecondary {
  background-color: #4e545b;
  color: #fff;
}
.labelwarning {
  background-color: #ffb400;
  color: #212529;
}
.labelinfo {
  background-color: #00b8d8;
  color: #fff;
}
.labelsuccess {
  background-color: #09ab6f;
  color: #fff;
}
.labeldanger {
  background-color: #ea234d;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/suspectTransaction.vue